import React from 'react';

export default () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        d="M9.33203 8.99996C9.88432 8.99996 10.332 8.55224 10.332 7.99996C10.332 7.44767 9.88432 6.99996 9.33203 6.99996C8.77975 6.99996 8.33203 7.44767 8.33203 7.99996C8.33203 8.55224 8.77975 8.99996 9.33203 8.99996Z"
        fill="#261B36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66536 2.66663V14H0.332031V15.3333H13.6654V14H12.332V2.66663C12.332 1.56206 11.4366 0.666626 10.332 0.666626H3.66536C2.5608 0.666626 1.66536 1.56206 1.66536 2.66663ZM10.332 1.99996H3.66536C3.29717 1.99996 2.9987 2.29844 2.9987 2.66663V14H10.9987V2.66663C10.9987 2.29844 10.7002 1.99996 10.332 1.99996Z"
        fill="#261B36"
      />
    </svg>
  );
};
